import { hasFeatureAccess } from "$lib/utils/planUtils"

const GROWTH_FEATURES = [
  "Follow on Instagram",
  "Enter Secret Code",
  "Invite Friends",
  "Internal List",
  "Follow on TikTok",
  "Join a Private Group",
  "Join a Public Group",
  "Follow me on Spotify",
  "Follow me on Apple Music",
  "Custom Action",
  "Visit Reddit Post",
  "Visit Subreddit",
  "Visit Pinterest Page",
  "Subscribe to Podcast",
]

const PREMIUM_FEATURES = [
  "Custom Action",
  "Follow Company on LinkedIn",
  "Like LinkedIn Post",
  "Share LinkedIn Post",
  "Book an Appointment",
  "Write a Google Review",
  "Write a Trustpilot Review",
  "Submit a Youtube Video",
  "Coupon Wheel",
]

export function userHasAccessToAction(action, userPlan) {
  // Handle cases where action might be undefined or null
  if (!action) return false

  // Handle cases where action.name might be undefined
  const actionName = action.name || ""

  // Check for premium features
  if (PREMIUM_FEATURES.includes(actionName)) {
    return {
      hasAccess: hasFeatureAccess(userPlan, "Premium"),
      planRequired: "Premium",
    }
  }

  if (GROWTH_FEATURES.includes(actionName)) {
    return {
      hasAccess: hasFeatureAccess(userPlan, "Growth"),
      planRequired: "Growth",
    }
  }

  return {
    hasAccess: true,
    planRequired: null, // No specific plan required for other actions
  }
}

// Updated helper function to handle empty objects
export function findSetting(action, settingName) {
  // Check if action exists and settings is an array
  if (
    !action?.settings ||
    !Array.isArray(action.settings) ||
    action.settings.length === 0
  ) {
    return undefined
  }
  return action.settings.find((s) => s.name === settingName)
}
